"use client";

import { c as _c } from "react/compiler-runtime";
import { FormEvent, useEffect, useRef, useState } from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SendIcon } from "lucide-react";
import Image from "next/image";
import { ToolData } from ".";
type Message = {
  text: string;
  sender: "user" | "bot";
};
const supportResponses = ["Did you try turning it off and on again?", "Did you delete your node_modules and re-install?", "Did you update your environment variables?", "Did you try Googling it?", "Did you try doing what the error message says?", "Did you clear your cache?", "Have you checked whether you are looking in the right environment?"];
function RubberDuck(t0) {
  const $ = _c(21);
  const {
    title,
    description
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [messages, setMessages] = useState(t1);
  const formRef = useRef(null);
  const chatRef = useRef(null);
  const inputRef = useRef(null);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      e.preventDefault();
      const formData = new FormData(e.target as HTMLFormElement);
      const message = formData.get("message") as string;
      if (!message) {
        return;
      }
      const newMessages = [{
        text: message,
        sender: "user"
      }];
      const randomIndex = Math.floor(Math.random() * supportResponses.length);
      const botResponse = supportResponses[randomIndex];
      setTimeout(() => {
        setMessages([...newMessages, {
          text: botResponse,
          sender: "bot"
        }]);
      }, 500);
      formRef.current?.reset();
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleSubmit = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      chatRef.current?.scrollTo({
        top: chatRef.current.scrollHeight,
        behavior: "smooth"
      });
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== messages) {
    t4 = [messages];
    $[3] = messages;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== title) {
    t5 = <CardTitle>{title}</CardTitle>;
    $[5] = title;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== description) {
    t6 = <CardDescription>{description}</CardDescription>;
    $[7] = description;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <CardHeader className="border-b">{t5}{t6}</CardHeader>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== messages) {
    t8 = messages.length === 0 ? <div className="text-muted-foreground text-center">Ask me any tech question!</div> : messages.map(_temp);
    $[12] = messages;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <CardContent ref={chatRef} className="h-96 overflow-y-auto border-b">{t8}</CardContent>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Input ref={inputRef} name="message" type="text" placeholder="Type your message..." autoFocus={true} />;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <CardFooter><form ref={formRef} onSubmit={handleSubmit} className="flex flex-row gap-4">{t10}<Button type="submit"><SendIcon size={24} /></Button></form></CardFooter>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t7 || $[19] !== t9) {
    t12 = <Card className="mx-auto w-full">{t7}{t9}{t11}</Card>;
    $[18] = t7;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
}
function _temp(message_0, index) {
  return <div key={index} className={`flex flex-row items-end gap-2 pb-4 ${message_0.sender === "user" ? "justify-end text-right" : "justify-start text-left"}`}>{message_0.sender === "bot" ? <div className="bg-muted flex h-9 w-9 items-center justify-center rounded-full"><Image src="/images/rubber-duck.png" alt="Rubber Duck" width={20} height={20} className="inline-block object-contain" priority={true} /></div> : null}<div className={`inline-block px-4 py-2 ${message_0.sender === "user" ? "bg-primary text-primary-foreground justify-start rounded-tl-lg rounded-r-lg" : "bg-secondary text-secondary-foreground rounded-l-lg rounded-br-lg"}`}>{message_0.text}</div></div>;
}
export { RubberDuck };